import { FC, useMemo } from 'react';
import { stepsList, StepsType } from '../../model';
import s from './index.module.css';

type ScanProps = {
    step: StepsType;
};

const texts: Record<StepsType, string> = {
    home: '',
    signup: 'We have just started scanning your hosts & APIs. Finish the registration to see the results.',
    personal:
        'After we identified your hosts, we search for APIs on them. As soon as we found hosts and API we are testing your WAFs.',
    team: 'We check threats your WAFs can detect. When WAFs are fully tested we are searching for vulnerabilities such as API Leaks.',
    role: 'Discovery results are useful for security, software & devops professionals. For every teammate AASM provides different value',
    invite: 'Surprise your team with results. Invite them too. It’s free!',
    solutions: 'By the way, do you have any API security in place?',
    purpose: 'Last question. What scanning capabilities are you looking for?'
};

export const Scan: FC<ScanProps> = ({ step }) => {
    const total = stepsList.length;
    const percent = useMemo(() => (stepsList.indexOf(step) / total) * 100, [step]);

    return (
        <div>
            <p className={s.text}>{texts[step]}</p>
            <div className={s.bar}>
                <div className={s.completed} style={{ width: `${percent}%` }} />
                <div className={s.progress} style={{ width: `${(1 / total) * 100}%` }} />
            </div>
        </div>
    );
};
